// extracted by mini-css-extract-plugin
module.exports = {"container":"fractional__container___1QNKU","denum-exist":"fractional__denum-exist___2kuwF"};